import React, { Component } from 'react';
import { Modal, Form, FormGroup, Checkbox, ButtonToolbar, Button } from 'react-bootstrap';

export class DownloadMultipleDocumentsForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                downloadSvg: false,
                downloadPdf: false
            }
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { data } = this.state;

        data[property] = e.target.value;

        this.setState({
            data: data
        });
    }

    onCheckValue(e, property) {
        const { data } = this.state;

        data[property] = e.target.checked;

        this.setState({
            data: data
        });
    }

    onConfirm() {
        const { data } = this.state;
        this.props.onConfirm(data);
    }

    // -------------------

    render() {
        const { data } = this.state;
        const { title } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formDownloadSvg">
                            <Checkbox className="form-checkbox"
                                defaultChecked={data.downloadSvg}
                                onChange={(e) => this.onCheckValue(e, "downloadSvg")}>
                                SVG
                            </Checkbox>
                        </FormGroup>
                        <FormGroup controlId="formDownloadPdf">
                            <Checkbox className="form-checkbox"
                                defaultChecked={data.downloadPdf}
                                onChange={(e) => this.onCheckValue(e, "downloadPdf")}>
                                PDF
                            </Checkbox>
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onConfirm()}> CONFIRMAR </Button>
                        <Button onClick={() => this.props.onCancel()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
